function getGaCookieValue(idType) {
    const patterns = {
        client_id: /_ga=GA\d\.\d\.(.+?);/,
        session_id: /_ga_[A-Z0-9]+=GS\d\.\d\.s(\d+)\$/
    };

    try {
        if (idType !== 'client_id' && idType !== 'session_id') {
            throw new Error('idType must be \'client_id\' or \'session_id\'');
        }

        const match = document.cookie.match(patterns[idType]);
        const id = match?.[1]?.trim();

        if ((id?.trim() ?? '').length <= 0) {
            throw new Error('No value for \'id\'');
        }

        return id;
    } catch (error) {
        window.bugsnagClient.notify(new Error(`[Google Analytics] Failed to get GA idType '${idType}': ${error.message}`));
        return null;
    }
}
window.getGaCookieValue = getGaCookieValue;

async function gTagGetFieldValue(fieldId) {
    const TIMEOUT_MS = 3000;
    const targetId = window.SHARED.googleAnalyticsMeasurementId;

    try {
        if (!targetId?.trim()) {
            throw new Error('Missing Google Analytics Measurement Id');
        }

        if (fieldId !== 'client_id' && fieldId !== 'session_id') {
            throw new Error('fieldId must be \'client_id\' or \'session_id\'');
        }

        const id = await Promise.race([
            new Promise((resolve) => {
                window.gtag('get', targetId, fieldId, resolve);
            }),
            new Promise((_, reject) =>
                setTimeout(() => reject(new Error(`Timeout after ${TIMEOUT_MS}ms`)), TIMEOUT_MS)
            )
        ]);

        if ((id?.trim() ?? '').length <= 0) {
            throw new Error('No value for \'id\'');
        }

        return id;
    } catch (error) {
        window.bugsnagClient.notify(new Error(`[Google Analytics] Failed to get GA fieldId '${fieldId}': ${error.message}`));
        return null;
    }
}
window.gTagGetFieldValue = gTagGetFieldValue;

window.disableElement = function(target) {
    target.prop('disabled', true);
};

window.setElementIcon = function(target, icon) {
    var type = target.is('button') ? 'html' : 'val';

    icon = (type == 'html') ? '<i class="fas fa-spinner fa-spin"></i>' : '...';

    var content = getElementVal(target);

    target[type](icon + ' ' + content);
};

window.hasFormValidation = function() {
    return (typeof document.createElement('input').checkValidity == 'function');
};

var getElementVal = function(target) {
    var type = target.is('button') ? 'html' : 'val';

    return target[type]();
};

window.snakeCase = function(string) {
    return string.replace(/\W+/g, " ")
        .split(/ |\B(?=[A-Z])/)
        .map(word => word.toLowerCase())
        .join('_');
};

window.bugsnagClientNotify = function (message) {
    if (window.bugsnagClient) {
        window.bugsnagClient.notify(message);
    }
}
